export function buildValidator (...validators) {
    return function validate (applyValidation, value) {
        if (!applyValidation || !validators || validators.length === 0) {
            return { valid: true }
        }

        const failing = validators.find(v => v(value) !== true)

        return {
            valid: !failing,
            message: failing && failing(value)
        }
    }
}